export type SearchQueryModel = {
    query: string
    features: string[]
    lang: string
}

export enum HitLinkCategory {
    Page = 'Page',
    MyPages = 'MyPages',
    News = 'News',
    Document = 'Document',
}

export type SearchResultItem = {
    title: string
    url: string
    excerpt: string
    features: string[]
    hitType: string
    hitId: string
    score: number
    keywords: string[]
    hitCategory: HitCategory
    icon: string
    hitLinkCategory: HitLinkCategory
    date: string
}

export interface ISearchResultsResponse {
    query: SearchQueryModel
    items: SearchResultItem[]
}

export enum HitCategory {
    EService = 'EService',
    Default = 'Default',
    Faq = 'Faq',
    Document = 'Document',
}

export interface ISearchResult {
    searchHits?: SearchResultItem[],
    totalHits?: number,
    status?: number,
}
